module.exports = __webpack_public_path__ + "static/img/logo4.5a5729a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo4.png
// module id = VyHB
// module chunks = 0